var map = {
	"./steetplaychildmarriage1.jpeg": 4173,
	"./steetplaychildmarriage2.jpeg": 5884,
	"./steetplayelection1.jpeg": 7654,
	"./steetplayelection2.jpeg": 3923,
	"./steetplayplasticpollution1.jpeg": 6593,
	"./steetplayplasticpollution2.jpeg": 9360,
	"./steetplayroadsafety1.jpg": 4206,
	"./steetplayroadsafety2.jpeg": 7342,
	"./steetplayroadsafety3.jpg": 591,
	"./steetplayroadsafety4.jpeg": 7744,
	"./steetplayroadsafety5.jpg": 7754,
	"./steetplayroadsafety6.jpeg": 1594,
	"./steetplayroadsafety7.jpeg": 5089,
	"./steetplayswatchhata1.jpg": 8498,
	"./steetplayswatchhata2.jpg": 1405,
	"./steetplayswatchhata3.jpg": 480,
	"./steetplayswatchhata4.jpg": 8483,
	"./steetplayswatchhata5.jpg": 9958,
	"./steetplaywildlifeweek1.jpeg": 1097,
	"./steetplaywildlifeweek2.jpeg": 3704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3504;